class IM_Synco_Diagram {
    /** @type {HTMLElement} */
    #$element;

    /** @type {number|null} */
    #activeItemIndex;

    /** @type {number|null} */
    #visibleItemIndex;

    /** @type {boolean} */
    #autoPlay;


    constructor($element) {
        this.#$element         = $element;
        this.#activeItemIndex  = null;
        this.#visibleItemIndex = null;
        this.#autoPlay         = true;
    }

    initialize() {
        this.#activeItemIndex  = 0;
        this.#visibleItemIndex = 0;
        this.#updateActiveItem();

        const $items = this.#$element.querySelectorAll(".synco-diagram-item[data-index]");

        for (const $item of $items) {
            $item.addEventListener("click", this.#onItemClick.bind(this));
            $item.addEventListener("mouseenter", this.#onItemMouseEnter.bind(this));
            $item.addEventListener("mouseleave", this.#onItemMouseLeave.bind(this));
        }

        setInterval(this.#processAutoplay.bind(this), 2500);
    }

    #onItemClick(event) {
        const $item = event.currentTarget;
        const index = parseInt($item.getAttribute("data-index"));

        if (isNaN(index) || index === this.#activeItemIndex) {
            return;
        }

        this.#activeItemIndex  = index;
        this.#visibleItemIndex = index;
        this.#autoPlay         = false;
        this.#updateActiveItem();
    }

    #onItemMouseEnter(event) {
        const $item = event.currentTarget;
        const index = parseInt($item.getAttribute("data-index"));

        if (isNaN(index) || index === this.#visibleItemIndex) {
            return;
        }

        this.#visibleItemIndex = index;
        this.#updateActiveItem();
    }

    #onItemMouseLeave() {
        this.#visibleItemIndex = this.#activeItemIndex;
        this.#updateActiveItem();
    }

    #processAutoplay() {
        if (!this.#autoPlay) {
            return;
        }

        // Get index of new active item.
        let newActiveItem    = this.#activeItemIndex + 1;
        const $newActiveItem = this.#$element.querySelector(".synco-diagram-item[data-index='" + newActiveItem + "']");

        if (!$newActiveItem) {
            newActiveItem = 0;
        }

        // Make the item visible too if not hovered on something else.
        if (this.#visibleItemIndex === this.#activeItemIndex) {
            this.#visibleItemIndex = newActiveItem;
        }

        // Activate a new item.
        this.#activeItemIndex = newActiveItem;
        this.#updateActiveItem();
    }

    #updateActiveItem() {
        // Disable all items and texts.
        const $allItems = this.#$element.querySelectorAll(".synco-diagram-item[data-index]");
        const $allTexts = this.#$element.querySelectorAll(".synco-diagram-text[data-index]");

        for (const $item of $allItems) {
            $item.classList.remove("-active");
        }

        for (const $text of $allTexts) {
            $text.classList.remove("-active");
        }

        // Enable the active item and text.
        if (this.#visibleItemIndex !== null) {
            const $activeItem = this.#$element.querySelector(".synco-diagram-item[data-index='" +  this.#visibleItemIndex + "']");
            const $activeText = this.#$element.querySelector(".synco-diagram-text[data-index='" +  this.#visibleItemIndex + "']");

            if ($activeItem) {
                $activeItem.classList.add("-active");
            }

            if ($activeText) {
                $activeText.classList.add("-active");
            }
        }
    }
}


class IM_Tabs {
    #$element;

    #lock;


    constructor($element) {
        this.#$element = $element;
        this.#lock     = false;
    }

    initialize() {
        const $buttons = this.#$element.querySelectorAll(".synot-tablist .synot-tab");

        for (const $button of $buttons) {
            $button.addEventListener("click", () => {
                this.#switchTab($button.getAttribute("aria-controls"));
            });
        }
    }

    #switchTab(id) {
        // Check lock.
        if (this.#lock) {
            return;
        }

        // Get current and new active tab.
        const $currentTab = this.#$element.querySelector(".synot-tabpanel.-active");
        const $newTab     = this.#$element.querySelector(".synot-tabpanel[id='" + id + "']");

        if (!$newTab || $newTab === $currentTab) {
            return;
        }

        this.#lock = true;

        // Switch tabs buttons.
        const $buttons = this.#$element.querySelectorAll(".synot-tablist .synot-tab");

        for (const $button of $buttons) {
            if ($button.getAttribute("aria-controls") === id) {
                $button.classList.add("-active");
                $button.ariaSelected = "true";
            } else {
                $button.classList.remove("-active");
                $button.ariaSelected = "false";
            }
        }

        // Switch tabs.
        $currentTab.style.height = $currentTab.offsetHeight + "px";
        $newTab.style.height     = "0";

        setTimeout(() => {
            $currentTab.style.height = "0";
        }, 25);

        setTimeout(() => {
            $newTab.style.height = $newTab.scrollHeight + "px";
            $newTab.scrollIntoView({ behavior: "smooth" });
        }, 525);

        setTimeout(() => {
            $currentTab.classList.remove("-active");
            $newTab.classList.add("-active");

            $currentTab.ariaHidden = "true";
            $newTab.ariaHidden     = "false";

            $newTab.style.height = "";
            this.#lock = false;
        }, 1025);
    }
}


/** @var jQuery */
jQuery(document).ready(function ($) {
    // Bootstrap breakpoints.
    var breakpoints = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200
    };

    var site_header = $("#site-header");


    // Smooth scrolling.
    (function () {
        /**
         * Scrolls smoothly to given element.
         * @param selector
         */
        var scroll_to_element = function (selector) {
            var scroll_to = selector.offset().top;

            if (screen.width > breakpoints.xl) {
                scroll_to -= site_header.outerHeight();
            }

            if (scroll_to < 0) {
                scroll_to = 0;
            }

            $("html, body").animate({scrollTop: scroll_to}, 500);
        };


        // Automatically scroll to element when page loads.
        if (location.hash) {
            if (location.hash === "#") {
                return;
            }

            var selector = $(location.hash);

            if (selector.length === 0) {
                return;
            }

            scroll_to_element(selector);
        }

        // Scroll to element placed on the same page after anchor click.
        $("a[href^='#']").on("click", function (event) {
            var target_hash = $(event.currentTarget).attr("href");

            if (target_hash === "#") {
                return;
            }

            var target = $(target_hash);

            if (target.length === 0) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            scroll_to_element(target);
        });
    })();


    // Sticky header.
    (function () {
        var on_scroll = function() {
            var scroll_breakpoint = (screen.width < breakpoints.sm) ? 48 : 0;

            if ($(window).scrollTop() > scroll_breakpoint) {
                site_header.addClass("-sticky");
            } else {
                site_header.removeClass("-sticky");
            }
        };

        $(window).on("scroll", on_scroll);
        setTimeout(on_scroll, 50);
    })();


    // Main navigation.
    (function () {
        var navigation = $("#site-navigation");

        // Hamburger.
        var hamburger = $("#site-hamburger");

        hamburger.on("click", function () {
            if (navigation.hasClass("-active")) {
                navigation.removeClass("-active");
                hamburger.removeClass("-active");
            } else {
                navigation.addClass("-active");
                hamburger.addClass("-active");
            }
        });

        // Products menu.
        navigation.find("li.products-menu-parent > a").on("click", function (event) {
            event.preventDefault();
            event.stopPropagation();

            if (screen.width >= breakpoints.xl) {
                return;
            }

            $(this).parent().toggleClass("-active");
        });
    })();


    // Search form.
    (function () {
        var search_button = $("#site-search");
        var search_form   = $("#site-search-form");

        search_button.on("click", function () {
            if (search_form.hasClass("-active")) {
                search_button.removeClass("-active");
                search_form.removeClass("-active");
            } else {
                search_button.addClass("-active");
                search_form.addClass("-active");
            }
        });
    })();


    // Simple Lightbox.
    $(".lightbox-image").simpleLightbox();


    // Introduction.
    (function () {
        var introduction = $("#introduction");

        if (introduction.length === 0) {
            return;
        }

        var introduction_slides = introduction.find(".introduction-slide");

        if (introduction_slides.length < 2) {
            return;
        }

        introduction.owlCarousel({
            items: 1,
            loop: false,
            rewind: true,
            autoplay: true,
            autoplayTimeout: 7500,
            autoplayHoverPause: false,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
            nav: false,
            dots: true,
            animateOut: "fadeOut"
        });
    })();


    // Scroll top.
    (function () {
        var scroll_top = $("#scroll-top");

        if (scroll_top.length === 0) {
            return;
        }

        // Show / hide scroll control.
        var scroll_breakpoint = (screen.height / 2);

        var on_scroll = function() {
            if ($(window).scrollTop() > scroll_breakpoint) {
                scroll_top.addClass("-active");
            } else {
                scroll_top.removeClass("-active");
            }
        };

        $(window).on("scroll", on_scroll);
        setTimeout(on_scroll, 50);

        // On click.
        scroll_top.on("click", function () {
            $("html, body").animate({scrollTop: 0}, 500);
        });
    })();


    // Archive + Single - News.
    (function () {
        if (
            !document.body.classList.contains("blog")
            && !document.body.classList.contains("single-post")
        ) {
            return;
        }

        // Smooth showing of hidden news cards.
        var see_more    = $("#news-more");
        var news_list   = $("#news-list");
        var hidden_news = news_list.find("> .news-card-col-hidden");

        see_more.on("click", function () {
            // Hide button.
            see_more.animate({ opacity: 0 }, 250, "swing", function () {
                see_more.slideUp(250);
            });

            // Show news in delayed queue.
            var counter = 1;

            hidden_news.each(function () {
                var column = $(this);
                column.slideDown(250);

                setTimeout(function () {
                    column.animate({ opacity: 1 }, 250);
                }, (counter * 200));

                counter += 1;
            });
        });
    })();


    // Single - Products.
    (function () {
        if (!document.body.classList.contains("single-synot_product")) {
            return;
        }

        // Pictograms slider.
        const $pictograms_sliders = document.querySelectorAll(".pictograms-slider");

        for ( const $slider of $pictograms_sliders ) {
            const $slider_slides = $slider.querySelectorAll(".pictograms-slide");

            if ( $slider_slides.length < 2 ) {
                continue;
            }

            $($slider).owlCarousel({
                items: 1,
                rewind: true,
                autoplay: true,
                autoplayTimeout: 7500,
                nav: true,
                navText: [ "&#x2039;", "&#x203A;" ],
                dots: false
            });
        }

        // SYNCO diagrams.
        const $synco_diagrams = document.querySelectorAll(".synco-diagram");

        for ( const $diagram of $synco_diagrams ) {
            $diagram.diagram = new IM_Synco_Diagram( $diagram );
            $diagram.diagram.initialize();
        }

        // Tabs.
        const $tabs = document.querySelectorAll(".synot-tabs");

        for ( const $tab of $tabs ) {
            $tab.tabs = new IM_Tabs( $tab );
            $tab.tabs.initialize();
        }
    })();


    // Archive + Single - Careers.
    (function () {
        if (!document.body.classList.contains("post-type-archive-synot_job")
            && !document.body.classList.contains("single-synot_job")
        ) {
            return;
        }

        $(".careers-apply-button").on("click", function () {
            var careers_button = $(this);
            var careers_form   = careers_button.parent().find(".careers-apply-form");

            if (careers_form.length === 0) {
                return;
            }

            careers_button.fadeOut(350);
            careers_form.slideDown(350);
        });

        var progress_circles = $(".progress-circles-container .progress-circle");
        if (progress_circles.length > 0) {

            progress_circles.each(function() {
                var this_el = $(this);
                var this_height = this_el.height();

                this_el.whenInViewport(function($element) {
                    $element.addClass("-active");
                }, {
                    threshold: -(this_height * 0.75)
                });

            });

        }

    })();


    // Page - Contact.
    (function () {
        if (!document.body.classList.contains("page-template-template-contact")) {
            return;
        }

        /**
         * initMap
         *
         * Renders a Google Map onto the selected jQuery element
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   {jQuery} $el The jQuery element.
         * @return  object The map instance.
         */
        var initMap = function($el) {
            // Find marker elements within map.
            var $markers = $el.find('.marker');

            // Create gerenic map.
            var mapArgs = {
                zoom        : $el.data('zoom') || 16,
                mapTypeId   : google.maps.MapTypeId.ROADMAP
            };
            var map = new google.maps.Map( $el[0], mapArgs );

            // Add markers.
            map.markers = [];
            $markers.each(function(){
                initMarker( $(this), map );
            });

            // Center map based on markers.
            centerMap( map );

            // Return map instance.
            return map;
        }

        /**
         * initMarker
         *
         * Creates a marker for the given jQuery element and map.
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   {jQuery} $marker The jQuery element.
         * @param   {object} map     The map instance.
         * @return  object The marker instance.
         */
        var initMarker = function($marker, map) {

            // Get position from marker.
            var lat = $marker.data('lat');
            var lng = $marker.data('lng');
            var latLng = {
                lat: parseFloat( lat ),
                lng: parseFloat( lng )
            };

            // Create marker instance.
            var marker = new google.maps.Marker({
                position : latLng,
                map: map
            });

            // Append to reference for later use.
            map.markers.push( marker );

            // If marker contains HTML, add it to an infoWindow.
            if( $marker.html() ){

                // Create info window.
                var infowindow = new google.maps.InfoWindow({
                    content: $marker.html()
                });

                // Show info window when marker is clicked.
                google.maps.event.addListener(marker, 'click', function() {
                    infowindow.open( map, marker );
                });
            }
        }

        /**
         * centerMap
         *
         * Centers the map showing all markers in view.
         *
         * @date    22/10/19
         * @since   5.8.6
         *
         * @param   {object} map The map instance.
         * @return  void
         */
        var centerMap = function(map) {

            // Create map boundaries from all map markers.
            var bounds = new google.maps.LatLngBounds();
            map.markers.forEach(function( marker ){
                bounds.extend({
                    lat: marker.position.lat(),
                    lng: marker.position.lng()
                });
            });

            // Case: Single marker.
            if( map.markers.length === 1 ){
                map.setCenter( bounds.getCenter() );

                // Case: Multiple markers.
            } else{
                map.fitBounds( bounds );
            }
        }

        // Render maps on page load.
        $('.acf-map').each(function() {
            var map = initMap($(this));
        });
    })();
});
